'use client';
import "@/components/PopupModal/PopupModal.css";

/**
 * @description The PopupModal component is a reusable modal component that can be used to display messages or alerts to the user. It can be opened or closed based on the `open` prop.
 * @param {boolean} open Sets whether or not the popup is being displayed
 * @param {string} title The title of the popup
 * @param {string} message The message to display in the popup
 * @param {function} onClose The function to call when the popup is closed. The parent calling this modal is responsible for closing the modal by setting the "open" prop to false.
 * @returns 
 */
export default function PopupModal({ open, title, message, onClose }) {
  if (!open) return null;

  return (
    <div className="popupModalOverlay" onClick={onClose}>
      <div className="popupModalContent" onClick={(e) => e.stopPropagation()}>
        <div className="popupModal-header">
          <h2>{title}</h2>
          <button type="button" className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="popupModal-body">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
}